import Client from './client';

export default class ItemSalesMargins extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getSalesMargins(organization, experienceKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/${experienceKey}/sales-margins`, options);
  }

  postSalesMargins(organization, experienceKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/${experienceKey}/sales-margins`, {
      ...options,
       method: 'POST',
    });
  }

  getSalesMarginsAndVersions(organization, experienceKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/${experienceKey}/sales-margins/versions`, options);
  }

  getSalesMarginsByKey(organization, experienceKey, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/${experienceKey}/sales-margins/${key}`, options);
  }

  putSalesMarginsByKey(organization, experienceKey, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/${experienceKey}/sales-margins/${key}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteSalesMarginsByKey(organization, experienceKey, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/${experienceKey}/sales-margins/${key}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
